import {Kind} from '../types';

// Pure questions about a new-tell draft, shared by the store, the banner and the steps.

export const DRAFT_STALE_MS = 6 * 60 * 60 * 1000;

export interface DraftShape {
    kind: Kind | null;
    text: string;
    plants: string[];
    placeId: string | null;
    quantity: string;
    photos: {length: number};
}

/** Something worth keeping: words, a photo or a chosen kind. A bare default form is nothing. */
export const draftHasContent = (d: DraftShape): boolean => d.text.trim() !== '' || d.photos.length > 0 || d.kind !== null;

/** Where "Continue" lands: the words once a kind is chosen, the kind once there are photos, else the camera. */
export function draftEntryRoute(d: DraftShape): string {
    if (d.kind !== null) return '/tell/new/words';
    if (d.photos.length > 0) return '/tell/new/kind';
    return '/tell/new';
}

export const isStale = (updatedAt: string, now = Date.now(), maxAge = DRAFT_STALE_MS): boolean => {
    const t = Date.parse(updatedAt);
    return !Number.isFinite(t) || now - t > maxAge;
};

/** The banner's one-line description of a new-tell draft. */
export function draftLabel(d: DraftShape, kindLabel: (kind: Kind) => string): string {
    const firstLine = d.text
        .split('\n')
        .map(l => l.trim())
        .find(l => l !== '');
    const what = firstLine ? `“${firstLine.length > 40 ? `${firstLine.slice(0, 40)}…` : firstLine}”` : d.kind ? kindLabel(d.kind) : 'a new tell';
    const photos = d.photos.length > 0 ? ` · ${d.photos.length} ${d.photos.length === 1 ? 'photo' : 'photos'}` : '';
    return `${what}${photos}`;
}
